
/**
 * Module dependencies.
 */

import { ImageSource, Media } from './media';

/**
 * Export `payspaceSignupModes`.
 */

export const payspaceSignupModes = {
  private: 'private',
  public: 'public'
};

/**
 * Export `payspaceStatuses`.
 */

export const payspaceStatuses = {
  failed: 'failed',
  pending: 'pending',
  ready: 'ready',
  unconfigured: 'unconfigured'
};

/**
 * Export `PayspaceSignupMode` type.
 */

export type PayspaceSignupMode = keyof typeof payspaceSignupModes;

/**
 * Export `PayspaceStatus` type.
 */

export type PayspaceStatus = keyof typeof payspaceStatuses;

/**
 * Export `PayspaceCookie` type.
 */

export type PayspaceCookie = {
  email: string;
  logoUrl: string | null | undefined;
  name: string;
  slug: string;
};

/**
 * Export `MultiPayspaces` type.
 */

export type MultiPayspaces = Array<PayspaceCookie>;

/**
 * Export `Payspace` type.
 */

export type Payspace = {
  administratorEmail: string;
  background: Media | null | undefined;
  badges?: Array<string>;
  facebook: string | null | undefined;
  greeting: string | null | undefined;
  id: string;
  logo: ImageSource | null | undefined;
  name: string;
  ogImage: ImageSource | null | undefined;
  signupMode: PayspaceSignupMode;
  slack: string | null | undefined;
  slug: string;
  socialTags: Array<string>;
  status: PayspaceStatus;
  supportEmail: string | null | undefined;
  theme: object;
  title: string | null | undefined;
  totalUsers: number;
  twitter: string | null | undefined;
  whatsapp: string | null | undefined;
};
